// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"562b639d","450":"6a3f3570","488":"b15250ef","732":"26c0bceb","762":"1237962d","977":"05471b29"}[chunkId] + ".chunk.js";
};